import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n/i18n';
import store from './store';
import Vuex from 'vuex';
import ElementUI from 'element-ui';


/* <script src="../node_modules/@ckeditor/ckeditor5-build-classic/build/ckeditor.js"></script>
<script src="../node_modules/@ckeditor/ckeditor5-vue2/dist/ckeditor.js"></script> */


import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers,faPhoneVolume,faWrench } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add(faUsers)
library.add(faPhoneVolume)
library.add(faWrench)
Vue.component('font-awesome-icon', FontAwesomeIcon)


//library.add(faSignOutAlt)  
//Vue.component('font-awesome-icon', FontAwesomeIcon)


// import 'xe-utils'
// import VXETable from 'vxe-table'

// Vue.use(VXETable)

// 给 vue 实例挂载内部对象，例如：
// Vue.prototype.$XModal = VXETable.modal
// Vue.prototype.$XPrint = VXETable.print
// Vue.prototype.$XSaveFile = VXETable.saveFile
// Vue.prototype.$XReadFile = VXETable.readFile

// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import VeeValidate from 'vee-validate';

// import {
//   Button,
//   Input,
//   Table,
//   TableColumn,
//   Dialog,
//   Card,  
//   Icon,
//   Select,
//   Form,
//   Tag,
//   Tree,
//   Pagination,
//   Badge,
//   Loading,
//   Message,
//   MessageBox,
//   Menu,
//   Tabs,
//   TabPane,
//   Breadcrumb,
//   BreadcrumbItem,
//   Dropdown,
//   Steps,
//   Step,
//   Tooltip,
//   Popover,
//   Collapse,
//   FormItem,
//   Checkbox, 
//   CheckboxButton,
//   CheckboxGroup,
//   DropdownMenu,
//   DropdownItem,
//   Container,
//   Aside,
//   Main,
//   Header,
//   Footer,
//   MenuItem,
//   Submenu,
//   Option,
//   Col,
//   Row,
//   Upload,
//   Radio,
//   DatePicker,
//   TimePicker,
//   RadioGroup,
//   Link,
//   Switch,
// } from 'element-ui';
import './scss/theme-chalk/index.css';


import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use( CKEditor );

Vue.config.productionTip = false;
// const config = {
//   errorBagName: 'errorBags', // change if property conflicts.
//   fieldsBagName: 'fieldBags',
// };
// Vue.use(VeeValidate, config);
// Vue.use(VeeValidate);
Vue.use(Vuex);

//版面物件
// Vue.use(Row);
// Vue.use(Col);
// Vue.use(Aside);
// Vue.use(Main);
// Vue.use(Header);
// Vue.use(Container);
// Vue.use(Footer);

//form物件
// Vue.use(Link);
// Vue.use(Radio);
// Vue.use(RadioGroup);
// Vue.use(DatePicker, { enLocale });
// Vue.use(TimePicker, { enLocale });
// Vue.use(Upload);
// Vue.use(Option);
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);
// Vue.use(Checkbox);
// Vue.use(CheckboxButton);
// Vue.use(CheckboxGroup);
// Vue.use(FormItem);
// Vue.use(Collapse);
// Vue.use(Button);
// Vue.use(Input);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(Dialog);
// Vue.use(Card);
// Vue.use(Select);
// Vue.use(Form);
// Vue.use(Switch);

//其他物件
// Vue.use(Icon);
// Vue.use(Menu);
// Vue.use(Submenu);
// Vue.use(MenuItem);
// Vue.use(Tabs);
// Vue.use(TabPane);
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
// Vue.use(Dropdown);
// Vue.use(Tooltip);
// Vue.use(Pagination);
// Vue.use(Loading);
// Vue.use(Tag);
// Vue.use(Tree);

//暫時不會用到的物件
// Vue.use(Steps);
// Vue.use(Step);
// Vue.use(Badge);
// Vue.use(Popover);
Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.$alert = ElementUI.MessageBox.alert
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$ELEMENT = {size: 'small', zIndex: 3000, noDataText: 'no data found'};
Vue.config.lang = 'en';


// 檢查 localStorage 是否已有保存使用者選用的語系資訊
if (localStorage.getItem('footmark-lang')) {
  i18n.locale = localStorage.getItem('footmark-lang');
  store.commit('setLang', i18n.locale);
} else {
  store.commit('setLang', i18n.locale);
}


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
